<template>
  <div class="form-row d-info d-frame">
    <h3>Karta przedpłacona Xbox <span v-if="amount">– {{ amount }} zł</span></h3>
    <p>Produkt w wersji cyfrowej – natychmiastowa wysyłka kodu po dokonaniu zakupu.</p>
    <ul>
      <li>Karta przedpłacona Xbox to waluta dla graczy</li>
      <li>Łatwy i szybki sposób na zakup cyfrowej zawartości – gier i dodatków</li>
      <li>Idealny prezent dla gracza, jeśli nie znasz jego ulubionych gier</li>
      <li>Szybkie i łatwe zakupy bez konieczności posiadania karty kredytowej</li>
    </ul>

    <p><a href="" @click.prevent="showMore = true" v-if="!showMore">więcej informacji</a></p>
    <div v-if="showMore">
      <h3>Instrukcja wykorzystania</h3>
      <ol>
        <li>Kup wybraną kartę przedpłaconą Xbox.</li>
        <li>Wejdź na stronę <a href="https://microsoft.com/reedem" target="_blank">microsoft.com/reedem</a> i zaloguj się (*Nie masz jeszcze konta? Wejdź na stronę <a href="https://xbox.com/live" target="_blank">xbox.com/live</a> i utwórz nowe konto zgodnie z instrukcją, a następnie wpisz 25-cyfrowy kod).</li>
        <li>Wprowadź kod.</li>
        <li>Możesz rozpocząć zakupy w sklepie Xbox.</li>
      </ol>

      <h3>Główne korzyści</h3>
      <p><strong>Kupuj najnowsze gry, mapy, dodatki</strong></p>
      <p>Dzięki karcie przedpłaconej kupisz zarówno pełne wersje gier, jak i bonusowe misje fabularne, pakiety map do gry online oraz wiele innych dodatków. Najlepsze gry dostępne na Xbox One staną się jeszcze lepsze dzięki nowej zawartości, ktora wydłuży czas Twojego grania.</p>

      <h3>Najlepszy prezent dla gracza!</h3>
      <p>Chcesz podarować komuś grę, a nie wiesz który tytuł będzie najlepszym prezentem? Karta przedpłacona to pewny i prosty sposób by uszczęśliwić gracza, ktory po aktywacji karty sam wybierze sobie najbardziej interesującą go grę lub dodatek. Nie trać czasu na szukanie informacji i podaruj najlepszy prezent dla gracza.</p>

      <h3>Dostępne w różnych nominałach – 20, 50, 70, 100, 200 zł</h3>
      <p>Sam zdecyduj jaką kwotę chcesz przeznaczyć na zakupy najnowszych gier i dodatków. Karty przedpłacone dostępne są w czterech różnych nominałach: 20, 50, 70, 100 i 200 zł. Pozwala to lepiej zarządzać zakupami i wpłacać na swoje konto dokładnie taką kwotę, jakiej potrzebujesz.</p>

      <h3>Jedna karta, wiele możliwości</h3>
      <p>Swoje środki z karty przedpłaconej możesz wykorzystać do zakupu cyfrowej zawartości w sklepie Xbox na konsolach Xbox One i Xbox 360 oraz w sklepie Windows na urządzeniach z systemem Windows 10; komputerach, tabletach oraz smartfonach Lumia.</p>

      <h3>Prosta obsługa</h3>
      <p>Karty przedpłacone to prosta i bezpieczna forma zakupów cyfrowej zawartości. Jeśli nie posiadasz karty kredytowej lub nie chcesz jej używać online – to najprostszy sposób na zakup cyfrowej zawartości.</p>
      <p><a href="" @click.prevent="showMore = false">zwiń</a></p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TopupCodesInfoXboxOne',
  props: ['amount'],
  data () {
    return {
      showMore: false
    }
  }
}
</script>
